import css from 'styled-jsx/css';

export default css`
  .content-tools {
    width: 100%;
    max-width: 276px;
    display: flex;
    flex-direction: column;
    align-items: start;
    border-radius: 5px;
    font-family: 'Roboto-Medium';
    font-size: 10px;
  }
  @media (max-width: 767px) {
    .content-tools {
      width: 100%;
      max-width: 767px;
    }
  }
  .content-tools > *:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .content-tools > *:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .tools-list {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .tools-list > *:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .tool {
    width: 100%;
    padding: 5px 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    border: 1px solid transparent;
    background-color: #141414;
  }
  .tool-title {
    width: 100%;
    padding: 5px 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    border: 1px solid transparent;
    background-color: #a41c1c;
    border-radius: 5px;
  }
  .content-tools .tools-title.tool {
    padding: 0;
    background-color: #a41c1c;
  }
  @media (max-width: 767px) {
    .tool-title {
      cursor: pointer;
      padding: 5px 16px;
    }
    .tool.tools-title.bordered {
      border-radius: 5px;
    }
  }
  .arrow {
    display: none;
    padding: 15px;
    transition: all 0.2s ease-in-out;
  }
  @media (max-width: 767px) {
    .arrow {
      display: block;
      padding: 5px 16px;
    }
    .tools-list {
      display: none;
    }
  }
  .rotate-arrow {
    transform: rotate(90deg);
  }
  .openned {
    display: block;
  }
`;
